export enum CountableChannelType {
    Auto = 'auto',
    Immo = 'immo',
    Jobs = 'jobs',
}

export enum NotCountableChannelType {
    LocalInformation = 'local-information',
}

export const ChannelType = { ...CountableChannelType, ...NotCountableChannelType }

export type ChannelType = CountableChannelType | NotCountableChannelType

export interface ChannelCounts {
    location: string
    countDate: string
    countList: CountList[]
}

export interface CountList {
    channel: string
    count?: number
}
